import type { IconLoaders } from "../types";

/** File types, upload and download */
export const fileIcons = {
    document: () => import("./document"),
    download: () => import("./download"),
    excel: () => import("./excel"),
    folder: () => import("./folder"),
    json: () => import("./json"),
    pdf: () => import("./pdf"),
    tabular: () => import("./tabular"),
    upload: () => import("./upload"),
    xml: () => import("./xml"),
} satisfies IconLoaders;
